// Lumen 아이콘 시스템(Icon System.dc.html #14e) 정본 Lock / LockOpen — currentColor + 1.6px stroke 컨벤션을 따름
export function LockIcon({ className, ...props }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
            {...props}
        >
            <rect x="4" y="10.5" width="16" height="10.5" rx="2.5" />
            <path d="M7.5 10.5V7a4.5 4.5 0 0 1 9 0v3.5" />
        </svg>
    );
}

export function LockOpenIcon({ className, ...props }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
            {...props}
        >
            <rect x="4" y="10.5" width="16" height="10.5" rx="2.5" />
            <path d="M7.5 10.5V7a4.5 4.5 0 0 1 8.6-1.7" />
        </svg>
    );
}
